import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import useInvoices from 'components/Common/Members/Hooks/useInvoices';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import useSize from 'components/Common/Screen/Hooks/useSize';
import InvoiceCard from './InvoiceCard';

export default function Invoices({ withSection }) {
  const wrapper = useRef(null);
  const invoices = useInvoices();

  const size = useSize(wrapper);

  const content = (
    <>
      <h1 className="mb-3">Invoices</h1>

      {invoices === null && <LoadingPlaceholder text="Loading..." />}

      <div className="row container-fluid">
        {invoices !== null && invoices.map((invoice) => <InvoiceCard size={size} invoice={invoice} />)}
      </div>
    </>
  );

  return (
    <div ref={wrapper} className="content wallet">
      {withSection ? (
        <section>{content}</section>
      ) : (
        <div className="pb-5">{content}</div>
      )}
    </div>

  );
}

Invoices.propTypes = {
  withSection: PropTypes.bool.isRequired,
};
